module.exports = __webpack_public_path__ + "img/settings.11a77406.svg";